<template>
    <section class="contract-click-sign-flow-select-signers">
        <div class="select-signers">
            <span class="title-select-signers">2 - Selecionar Assinantes</span>
            <span class="subtitle-select-signers">
                Selecione os indivíduos e defina seus respectivos papeis no fluxo de assinatura do contrato.
            </span>
        </div>

        <div class="envelope-status scroll-color">
            <div class="marker-paper-signers">
                <section class="content-marker-paper-signers">
                    <div class="signers">
                        <span>Assinantes</span>
                    </div>

                    <div class="maker-paper">
                        <span class="paper">Papel</span>

                        <span class="proff-identity">Prova de Identidade</span>

                        <span class="can-refuse">Pode Recusar?</span>

                        <span class="receive-for-whatsapp">
                            Receber por WhatsApp?
                            <ui-tooltip-icon text="Selecione esta opção para receber o contrato pelo WhatsApp em vez de e-mail." link="https://ajuda.clicksign.com/article/785-assinando-via-whatsapp" size="sm" position-text="bottom"/>
                        </span>
                    </div>
                </section>

                <section class="draggable">
                    <draggable
                        :list="signers"
                        class="list-group"
                        ghost-class="ghost"
                        :animation="200"
                        @start="dragging = true"
                        @end="dragging = false"
                        @change="setSigners(signers)"
                    >
                        <div
                            v-for="(signer, index) in signers"
                            :key="index"
                            :class="{ 'select-last-child': (index + 1) === signers.length }"
                        >
                            <div class="select-signers-list">
                                <div class="draggables">
                                    <div class="drag-image" data-ui="button-move-signer-position">
                                        <img :src="require('@/assets/imgs/drag-and-drop.svg')" />
                                    </div>
                                    
                                    <div class="checkbox">
                                        <ui-checkbox
                                            v-model="signer.selected"
                                            :checked="signer.selected"
                                            :disabled="signer.type === 'customer'"
                                            design="mgb-0"
                                        />
                                    </div>

                                    <div class="text-user">
                                        <span class="label">{{ signer.name }}</span>

                                        <span class="perfil">{{ signer.label }}</span>
                                    </div>
                                </div>

                                <div class="action-select">
                                    <div class="action-select-card">
                                        <ui-select-v2
                                            v-model="signer.role"
                                            :data="roleOptions"
                                            :error="!!formValidation.errors[signer.group]?.role"
                                            :observation="formValidation.errors[signer.group]?.role"
                                            return-value="value"
                                            background-color="#FFF"
                                            placeholder="Selecione um papel"
                                            size="md"
                                            design="mgb-0"
                                            :show-footer="false"
                                        />
                                    </div>

                                    <div class="action-select-card">
                                        <ui-select-v2
                                            v-model="signer.auth"
                                            :data="authOptions"
                                            :error="!!formValidation.errors[signer.group]?.auth"
                                            :observation="formValidation.errors[signer.group]?.auth"
                                            return-value="value"
                                            background-color="#FFF"
                                            placeholder="Selecione uma prova de identidade"
                                            size="md"
                                            design="mgb-0"
                                            :show-footer="false"
                                        />
                                    </div>

                                    <div class="action-switch-card">
                                        <ui-switch
                                            v-model="signer.refusable"
                                            :checked="signer.refusable"
                                            design="sm mgb-0"
                                        />
                                    </div>

                                    <div v-if="signer.communicate_events" class="action-switch-card">
                                        <ui-switch 
                                            v-model="signer.communicate_events.signature_request"
                                            :checked="signer?.communicate_events?.signature_request === 'whatsapp'"
                                            value-true="whatsapp"
                                            value-false="email"
                                            design="sm mgb-0"
                                        />
                                    </div>

                                    <div v-if="signer.type === 'nonuser'" class="action-menu-card">
                                        <ui-menu-card icon="far fa-ellipsis-v">
                                            <button @click="editSigner(signer)">
                                                Configurações
                                            </button>
                                        </ui-menu-card>
                                    </div>
                                </div>
                            </div>

                            <div v-if="hasErrors(signer)" class="errors-list">
                                <ul>
                                    <li
                                        v-for="(error, index) in formValidation.errors[signer.group]"
                                        :key="index"
                                    >
                                        {{ error }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </draggable>
                </section>


                <span class="add-new-signers" @click="addSigner">
                    + Adicionar novo assinante
                </span>
            </div>

            <div class="footer-button">
                <ui-button
                    :disabled="!formValidation?.valid"
                    design="mw-200 primary lg"
                    @click="send"
                >
                    Solicitar Assinaturas
                </ui-button>
            </div>
        </div>

        <ui-add-signers-modal
            :has-documentation="envelope.has_documentation"
            mode="click_sign"
        />
    </section>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
	import { uiSelectV2, uiCheckbox, uiSwitch } from '@/components/ui/form'
    import { uiMenuCard, uiTooltipIcon } from '@/components/ui'
    import { uiAddSignersModal } from '@/components/ui-facilita/products'
	import draggable from 'vuedraggable'

    import { auths, clickRoles as roles } from '@/assets/js/data'

    import { mapActions, mapGetters } from 'vuex'

	export default {
		name: 'ui-click-sign-contract-sign-flow-select-signers',

		components: {
			uiButton,
            uiSelectV2,
            uiCheckbox,
            uiMenuCard,
            uiSwitch,
            uiAddSignersModal,
			draggable,
			uiTooltipIcon
		},

        data() {
            return {
                roleOptions: [...roles],
                authOptions: [...auths]
            }
        },

        computed: {
            ...mapGetters('digitalSignatureStore', {
                envelope: 'getEnvelope',
                signers: 'getSigners',
                formValidation: 'getFormValidation'
            })
        },

        watch: {
          signers: {
            immediate: true,
            handler(newSigners, oldSigners) {
              if (JSON.stringify(newSigners) !== JSON.stringify(oldSigners)) {
                this.setSigners(newSigners)
              }
            }
          }
        },

        mounted() {
            this.loadDealSigners()
        },

        methods: {
            ...mapActions('digitalSignatureStore', ['loadDealSigners', 'saveEnvelope', 'setSigners']),
            /**
             * Abre o modal para o cadastro de assinantes externos
             */
			addSigner() {
				this.$root.$emit('modal-open-click_sign-add-signers')
			},
            /**
             * Abre o modal para a edição de assinantes externos
             */
			editSigner(event) {
				this.$root.$emit('modal-open-click_sign-add-signers', event)
			},
            /**
             * Solicita o envio dos dados do envelope e caso esteja tudo correto, solicita
             * o fechamento do modal
             */
            send() {
                this.saveEnvelope().then(() => {
                    // Emite o evento para recarregar o component de Documentos e Contratos
                    let event = new CustomEvent('iframe--contracts-reload-page')
				    window.parent.document.dispatchEvent(event)
                    this.$emit('close')
                })
            },
            /**
             * Verifica se existem erros de formulário referentes a determinado assinante
             */
            hasErrors(signer) {
                return Object.keys(this.formValidation.errors[signer.group] || {}).length
            }
        }
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>